import { Text } from '@lmc/ui-kit/src/general'
import dayjs from 'dayjs'
import { TIME_FORMAT } from 'screens/Rostering/utils.datetime'
import styled from 'styled-components'

const Hour = ({ date }: { date: Date }) => (
  <HourContainer>
    <HourText>{dayjs(date).format(TIME_FORMAT)}</HourText>
  </HourContainer>
)

const HourText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

const HourContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
`

export default Hour
